import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClickLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1047_8728)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.99967 2.3335V1.3335M3.37345 3.37394L2.66634 2.66683M3.37345 8.66683L2.66634 9.37394M8.66634 3.37394L9.37345 2.66683M2.33301 6.00016H1.33301M5.66634 5.66683L8.40708 14.1853L10.333 12.2594L12.7404 14.6668L14.6663 12.7409L12.2589 10.3335L14.1849 8.40757L5.66634 5.66683Z",
			stroke: "#808080",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1047_8728",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgClickLight;
